'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Obog = void 0;
var $ = require("jquery");
var Obog = /** @class */ (function () {
    function Obog() {
        this.naviNumber = 1;
        this.naviBoxKey = '.trigObogNavi';
        this.naviBoxesKey = '.bulletObogNaviBoxes';
        this.specialBoxKey = '.bulletObogSpecialBox';
        this.specialBoxesKey = '.bulletObogSpecialBoxes';
        this.windowWidth = 0;
        this.naviBoxesWidth = 0;
        this.maxSlide = 0;
        this.naviBoxWidth = 0;
        this.specialBoxWidth = 0;
        var self = this;
        if ($(this.naviBoxesKey).length > 0) {
            this.naviNumber = Number($('#paramInitialNaviNumber').val());
            this.windowWidth = $(window).width();
            this.naviBoxesWidth = $(this.naviBoxesKey).width();
            this.maxSlide = this.windowWidth - this.naviBoxesWidth;
            this.naviBoxWidth = $(this.naviBoxKey).eq(0).width();
            this.specialBoxWidth = $(this.specialBoxKey).eq(0).width();
            if (this.windowWidth > 767) {
                // 初回の navi へ移動
                self.slide(this.naviNumber);
            }
            else {
                // スマホの処理
                console.log(this.naviNumber);
                self.scroll(this.naviNumber);
            }
        }
        // navi 移動
        $(this.naviBoxKey).click(function () {
            var number = $(this).data('number');
            self.slide(number);
        });
        // prev, next
        $('.trigObogPrevNext').click(function (e) {
            e.preventDefault();
            var type = $(this).data('type');
            var number = self.naviNumber;
            if (type == 'prev') {
                number--;
                if (number < 1) {
                    number = 1;
                }
            }
            else if (type == 'next') {
                number++;
                if (number > $(self.specialBoxKey).length) {
                    number = $(self.specialBoxKey).length;
                }
            }
            self.slide(number);
        });
    }
    Obog.prototype.slide = function (number) {
        var naviSlide = (this.naviBoxWidth + 5) * (number - 1) * -1;
        if (this.windowWidth > this.naviBoxWidth) {
            naviSlide += this.naviBoxWidth / 2;
        }
        else {
            naviSlide += this.windowWidth / 2;
        }
        if (naviSlide < this.maxSlide) {
            naviSlide = this.maxSlide;
        }
        else if (naviSlide > 0) {
            naviSlide = 0;
        }
        $(this.naviBoxesKey).css({ marginLeft: naviSlide });
        $(this.naviBoxKey).removeClass('current');
        $(this.naviBoxKey + '[data-number="' + number + '"]').addClass('current');
        var specialSlide = (this.specialBoxWidth) * (number - 1) * -1;
        $(this.specialBoxesKey).css({ marginLeft: specialSlide });
        this.naviNumber = number;
    };
    Obog.prototype.scroll = function (number) {
        // specialBoxKeyの位置を取得
        var positionY = $(".bulletObogSpecialBox[data-number=\"".concat(number, "\"]")).offset().top;
        var headerHeight = $('.header').outerHeight();
        //console.log(positionY);
        // スクロールする
        window.scrollTo({
            top: positionY - headerHeight,
            behavior: 'smooth',
        });
    };
    return Obog;
}());
exports.Obog = Obog;
exports.default = Obog;
